import { Box, Field, FieldLabelProps } from '@chakra-ui/react';
import { forwardRef } from 'react';
import InputField, { InputFieldProps } from './InputField';
import TextInput, { InputRef, TextInputProps } from './TextInput';

export interface InputLabelInsideProps extends TextInputProps {}

const InputLabelInside = forwardRef<InputRef, InputLabelInsideProps>((props, ref) => {
  return <TextInput ref={ref} visual="labelInsideInput" {...props} />;
});

interface InputLabelInsideFormControlProps extends InputFieldProps {
  label: string;
  fieldLabelProps?: FieldLabelProps;
  invalid?: boolean;
}

export function InputLabelInsideFormControl({
  label,
  fieldLabelProps,
  ...props
}: InputLabelInsideFormControlProps) {
  return (
    <InputField {...props} visual="insideInput" disabled={props.disabled}>
      <Box h="60px" w="100%">
        <Field.Label {...fieldLabelProps}>{label}</Field.Label>
        {props.children}
      </Box>
    </InputField>
  );
}

export default InputLabelInside;
